<template>
  <div>
    <div class="passwordBox">
      <p class="title">修改密码</p>
      <Form ref="searchForm" :label-width="100" :model="formItem" :rules="passwordruleRoleTable">
        <FormItem label="新密码" prop='password'>
          <Input v-model="formItem.password" password placeholder="请输入新密码" type="password"></Input>
        </FormItem>
        <FormItem label="新密码验证" prop='confirmPassword'>
          <Input v-model="formItem.confirmPassword" password placeholder="请输入新密码" type="password"></Input>
        </FormItem>
      </Form>
      <div class="commit">
        <p class="passwordMsg">提示：密码需要包含大写字母、小写字母、数字这三类字符，长度6-20个字符。</p>
      </div>
      <div class="footerButton">
        <Button type="default" @click="handleBack('add')">返回</Button>
        <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('searchForm')">
          <span v-if="!addLoading">提交</span>
          <span v-else>提交中</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import {loginPasswordEdit, loginProfile} from '@/api/login.js'

export default {
  name: 'password',
  data() {
    return {
      addLoading: false, // 提交时等待
      adminId: '', // 获取用户id
      formItem: {
        password: '',
        confirmPassword: ''
      },
      passwordruleRoleTable: {
        password: [{required: true, message: '新密码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/
              if (reg.test(value)) {
                callback()
              } else {
                callback(new Error('英文大小写、数字组合，6-20字符'))
              }
            },
            trigger: 'blur'
          }
        ],
        confirmPassword: [{required: true, message: '新密码验证不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.formItem.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      loginProfile().then(res => {
        this.adminId = res.data.data.adminId
      })
    },
    // 返回
    handleBack() {
      this.$router.go(-1)
    },
    // 提交
    handleCommit(name) {
      this.addLoading = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          // getKey().then((res) => {
          // let passwordNum = res.data.data
          loginPasswordEdit({
            // adminId: this.adminId,
            // password: this.$encruption(this.formItem.password, passwordNum)
            password: this.formItem.password
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.formItem = {}
              localStorage.removeItem('getToken')
              this.$router.push({name: 'login'})
            }
          }).catch(() => {
            this.$Message.error('修改密码失败')
            this.addLoading = false
          })
        } else {
          this.addLoading = false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.passwordBox {
  padding-bottom: 20px;
  margin: 0 auto;
  border: 0.0625rem solid #f2f2f2;
  background-color: #ffffff;

  /deep/ .ivu-form .ivu-form-item-label {
    /*  lable字靠右 */
    text-align: right;
  }

  /deep/ .ivu-input-wrapper {
    /*表单内input长度 */
    width: 20rem;
  }

  /deep/ .ivu-input {
    margin-left: 20px;
  }

  .title {
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    border-bottom: 1px solid rgb(205, 205, 205);
  }

  .commit {
    padding-left: 50px;

    .passwordMsg {
      font-size: 0.8rem;
      color: rgba(128, 122, 122);
      margin-bottom: 30px;
    }
  }
}
</style>
